module.exports = __webpack_public_path__ + "static/media/Authority Bias.7b93f97e.jpg";